import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IShipmentRoute {
  id: string | number;
  packageId: string | number;
  pointMapId: string | number;
  ord: number;
  status: number;
  updateDate: string;
  sessionId: string | number;
  iademi: number;
  createDate: string;
  /** Gerçek araca yüklenme anı (ayak olayları; 26 Eki 2026 öncesi ve eski PHP okutmalarında yok) */
  loadedAt?: string | null;
  /** Yükleme okutmasını yapan kişi ("Otomatik" = sistem) */
  loadedBy?: string | null;
  /** Ayağın tamamlandığı an (indirme / çıkış onayı / teslim) */
  completedAt?: string | null;
  completedBy?: string | null;
  /** Gönderici gizleme: sunucu etiketleri (korunan noktada görünen ad; pointMapId null olabilir) */
  fromLabel?: string | null;
  toLabel?: string | null;
  routeLabel?: string | null;
}

export class IShipmentListResponse extends IPagination {
  @Type(() => IShipmentRoute)
  results: IShipmentRoute[];
}
export class IShipmentQueryDto extends IQueryPaginationDto {
  pac_id?: string | number;
  session_id?: string | number;
  routeId?: string | number;
  status?: number;
  packageStatus?: number;
}

export class IPatchShipmentRouteBodyDto {
  package_id?: number;
  point_map_id?: number;
  ord?: number;
  status?: number;
  update_date?: Date;
  sessionId?: number | string;
  iademi?: number;
}

export class IShipmentRouteWaybillResponse {
  count: number;
  desi: number;
  barcodes?: string[];
  pointId: number;
  routeId: number;
  routeName: string;
  pointName: string;
  companyId: number;
  companyName: string;
  toCity?: string;
  toSubCity?: string;
  toPhoneNo?: string;
  /** Gönderici gizleme: gruptaki bir paket gizli → companyName görünen ad, routeName boş (BE maskeli) */
  senderHidden?: boolean;
}

export class IShipmentRouteWaybillListResponse extends IPagination {
  @Type(() => IShipmentRouteWaybillResponse)
  results: IShipmentRouteWaybillResponse[];
}
